module.exports = __webpack_public_path__ + "img/richards-bay-logo-icon.1a8dd513.png";